define.alias("shared/utils/uuid", "calendar/utils/uuid");